import React, { type JSX } from 'react';

import { stringSearchService, defaulComparator } from '@services/StringSearchService';

interface HighlightedTextProps {
  text: string;
  terms: string[];
}

/**
 * Wraps matches of any `term` in `<span class="highlight">` (diacritics- and
 * Cyrillic-insensitive, see StringSearchService). Rendered as React text nodes,
 * so content is always escaped.
 */
export default function HighlightedText({ text, terms }: HighlightedTextProps): JSX.Element {
  if (!text || terms.length === 0) {
    return <span>{text}</span>;
  }

  const matches = stringSearchService.markMatches(text, terms, defaulComparator);
  return (
    <span>
      {matches.map((m, i) => (m.isMatch
        ? <span key={i} className="highlight">{m.text}</span>
        : <React.Fragment key={i}>{m.text}</React.Fragment>))}
    </span>
  );
}
